import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, Matching } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useMatchingQuery(
	dealGuid?: Guid | undefined,
	options?: Omit<UseQueryOptions<Matching, unknown, Matching, any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Matching.Get(dealGuid),
		() => AxiosUtils.getResponseData<Matching>(api.get(CerebroApiEndpoints.Matching.Get(dealGuid))),
		options
	);
}
